import { Eyebrow, Reveal } from '@/components/Reveal';
import { useLanguage } from '@/context/LanguageContext';

export default function SectionHeading({ eyebrow, title, sub, align = 'center', light = false }) {
  const { t } = useLanguage();
  const alignCls = align === 'center' ? 'text-center items-center mx-auto' : 'text-start items-start';
  return (
    <div className={`flex max-w-2xl flex-col gap-4 ${alignCls}`}>
      <Reveal><Eyebrow light={light}>{t(eyebrow)}</Eyebrow></Reveal>
      <Reveal delay={0.08}>
        <h2 className={`font-display text-3xl font-extrabold tracking-tight sm:text-4xl ${light ? 'text-white' : 'text-brand-ink'}`} data-testid={`heading-${eyebrow}`}>{t(title)}</h2>
      </Reveal>
      {sub && (
        <Reveal delay={0.16}>
          <p className={`text-base leading-relaxed sm:text-lg ${light ? 'text-brand-dim' : 'text-brand-steel'}`}>{t(sub)}</p>
        </Reveal>
      )}
    </div>
  );
}
